import type { FC } from 'react';
import { StyleSheet } from 'react-native';
import Animated, { useAnimatedStyle } from 'react-native-reanimated';

import { ActiveRegionFilter } from '@/features/geo-area/components/region/ActiveRegionFilter';
import { useRegionTab } from '@/features/geo-area/components/region/RegionTab';
import type { RegionFilterChange } from '@/features/geo-area/components/region/regionTypes';

export const RegionFilterBar: FC<{
  onChange: (change: RegionFilterChange) => void;
}> = ({ onChange }) => {
  const { activeTab, scrollY, feedInset } = useRegionTab();
  const filterStyle = useAnimatedStyle(() => {
    'worklet';
    return { transform: [{ translateY: -Math.max(scrollY.value, 0) }] };
  });

  return (
    <Animated.View style={[styles.filter, { top: feedInset }, filterStyle]}>
      <ActiveRegionFilter activeTab={activeTab} onChange={onChange} />
    </Animated.View>
  );
};

const styles = StyleSheet.create({
  filter: {
    position: 'absolute',
    left: 0,
    right: 0,
    zIndex: 1
  }
});
